type BrowserOS = 'Mac' | 'Windows' | 'Linux'

/**
 * Returns the browser OS by using the navigator userAgent.
 *
 * It will default to Windows if the userAgent is not available because Windows is
 * the most common OS amongst our users
 * @returns  'Mac' | 'Windows' | 'Linux'
 */
export function useBrowserOS(): BrowserOS {
  if (!navigator?.userAgent) {
    return 'Windows'
  }

  const isMac = navigator.userAgent.indexOf('Mac') !== -1

  if (isMac) {
    return 'Mac'
  }

  const isLinux = navigator.userAgent.indexOf('Linux') !== -1

  if (isLinux) {
    return 'Linux'
  }

  return 'Windows'
}
